import { render, staticRenderFns } from "./xueyaji.vue?vue&type=template&id=05bb9f52&scoped=true&"
import script from "./xueyaji.vue?vue&type=script&lang=js&"
export * from "./xueyaji.vue?vue&type=script&lang=js&"
import style0 from "./xueyaji.vue?vue&type=style&index=0&id=05bb9f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb9f52",
  null
  
)

export default component.exports